module.exports = __webpack_public_path__ + "static/media/callback-min.c4523060.png";